import css from '../tpl-css/style-section-card-sona.js';
const html = `
<style>${css}</style>
<div data-attribute="card-container" data-background="#f5f5f5" style="background-color: rgb(245, 245, 245);">
    <div class="container-page">
       <div class="wrap-card container">
            <div data-attribute="card-item-image" data-order="1" class="card-item-image" style="order: 1;">
                <div class="wrap-img">
                <img loading="lazy" data-attribute="card-image" class="card-image" src="https://cdn.skywarex.com/images/2025/08/30/image-68b27e4867bd5864ecf01a4c.webp?w=50&amp;h=50&amp;q=80" alt="">
                </div>
            </div>
            <div data-attribute="card-item-content" data-order="2" class="card-item-content" data-style-center-y="true" style="order: 2;">
                <div data-attribute="card-content" class="card-content">
                <div data-attribute="card-title"><h2 style="text-align:center;">Your Kitchen, Our Passion</h2></div>
                <div data-attribute="card-description"><p style="text-align:center;">At Anitho, we're passionate about transforming kitchens into spaces of creativity and convenience. Our thoughtfully designed tools and products are crafted to make cooking simpler, faster, and more enjoyable. Explore innovation, quality, and style with us!</p></div>
                </div>
                <div data-attribute="card-btn-row" data-show-btn="true" class="row-btn" style="display: block;">
                <a data-background="#2d521d" data-radius="0" data-color="#FFFFFF" data-attribute="card-btn" class="card-btn" href="#" style="background-color: #2d521d; border-radius: 0px; color: #FFFFFF;">Read more</a>
                </div>
            </div>
       </div>
    </div>
</div>
`;
export default html;
